import { Spinner } from '@change/ds-core-ui';

import { withPrefetchedData } from 'src/shared/prefetch';

import type { TeamPagePrefetchedDataProps } from 'src/app/pages/about/team/pageContext';
import { prefetchPageContext, TeamPageContextProvider } from 'src/app/pages/about/team/pageContext';

import { Layout } from '../layout';

import { TeamErrorHandler } from './ErrorHandler';

const OG_IMAGE = '/brand-pages/about/opengraph-about.jpg';

export const Team = withPrefetchedData(
	function Team({ prefetchedData }: TeamPagePrefetchedDataProps) {
		return (
			<TeamPageContextProvider
				prefetchedData={prefetchedData}
				errorHandler={TeamErrorHandler}
				loadingFallback={<Spinner className="mx-auto my-64" />}
			>
				<Layout />
			</TeamPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchData: async (context) => prefetchPageContext(context),
		pageTitle: ({ i18n, fromTemplate }) => fromTemplate(i18n.translate('fe.pages.about_team.title')),
		pageMetadata: ({ i18n, getStaticAssetUrl }) => {
			const title = i18n.translate('fe.pages.about_team.title');
			const description = i18n.translate('fe.pages.about_team.description');
			return {
				description,
				ogTitle: title,
				ogDescription: description,
				ogImage: getStaticAssetUrl(OG_IMAGE),
				ogType: 'website',
				twitterCard: 'summary',
				twitterImage: getStaticAssetUrl(OG_IMAGE),
				twitterImageAlt: title,
			};
		},
	},
);
